/*** 
 * 描述：系统公共的404找不到页面部分
 */ 
import { Component } from '@angular/core';
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';

@Component({
  selector: 'sw-404',
  templateUrl: './404.html',
})

export class SwException404Component {
  /**
   * 默认主页地址
   */
  defaultPortal: string = ''
  constructor(
    private router: Router, //路由服务
  ) { 
    this.defaultPortal = environment.defaultPortal;
  }
  /**
   * 返回主页
   */
  goBackDashboard(){
    this.router.navigate([this.defaultPortal]);
  }
}